import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'on-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {
    @Input() title;
    constructor() {}

    ngOnInit() {}
}
